const gtag: any = function () {
    if (window && (window as any)["dataLayer"]) {
        (window as any)["dataLayer"].push(arguments);
    }

}

export const googleActionStart = () => {
    gtag('event', 'quiz_start', {
        event_category: 'quiz',
        event_label: 'Quiz Started',
        value: 1
    })
}

export const googleActionClickNext = (step: number) => {
    gtag('event', 'quiz_next_question', {
        event_category: 'quiz',
        event_label: 'Next Question',
        value: step
    })
}

export const googleActionResult = () => {
    gtag('event', 'quiz_result_contact_form', {
        event_category: 'quiz',
        event_label: 'Result to Contact Form',
        value: 1
    })
}

export const googleActionThanks = () => {
    gtag('event', 'lead_submit', {
        event_category: 'form',
        event_label: 'Thank You Page',
        value: 1
    })
}